// src/components/pages/ProductDetailPage.js

import React from 'react';
import ProductDetails from '../elementsui/ProductDetails';
import BottomCartNav from '../Header/BottomCartNav';

const ProductDetailPage = () => {
  return (
    <div>
      <ProductDetails />
      <BottomCartNav />
    </div>
  );
};

export default ProductDetailPage;
